import styled from '@emotion/styled';
import { Button } from '@chakra-ui/react';

export const PrimaryButton = styled(Button)`
  background: ${({ theme }) => theme.colors.highlight};
  color: ${({ theme }) => theme.colors.white};
  padding: 24px 16px;
  border-radius: 12px;

  &:hover {
    background: ${({ theme }) => theme.colors.highlight};
  }

  &:active {
    background: ${({ theme }) => theme.colors.highlight};
  }
`;

export const RoundButton = styled(PrimaryButton)`
  padding: 0;
  height: 36px;
  min-width: 36px;
  border-radius: 24px;
`;

export const StepSelectButton = styled(Button)`
  background-color: ${({ theme }) => theme.colors.white};
  border: none;
  border-radius: 12px;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  height: 40px;

  @media (min-width: ${({ theme }) => theme.breakpoints.xs}) {
    height: 70px;
  }
`;
